export default __webpack_public_path__ + "static/media/users-stats-icon.d1be5c7d.svg";